import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27921798"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body py-4" }
const _hoisted_6 = { class: "d-flex gap-4" }
const _hoisted_7 = { class: "borders" }
const _hoisted_8 = { class: "head" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "borders" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Party ID", -1))
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "borders" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "UID", -1))
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "borders" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Account ID", -1))
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "borders" }
const _hoisted_20 = { class: "head" }
const _hoisted_21 = { class: "content" }
const _hoisted_22 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "borders" }
const _hoisted_25 = { class: "head" }
const _hoisted_26 = { class: "content" }
const _hoisted_27 = { class: "px-2" }
const _hoisted_28 = { class: "title" }
const _hoisted_29 = { class: "d-flex gap-4" }
const _hoisted_30 = { class: "borders" }
const _hoisted_31 = { class: "head" }
const _hoisted_32 = { class: "content" }
const _hoisted_33 = { class: "borders" }
const _hoisted_34 = { class: "head" }
const _hoisted_35 = { class: "content" }
const _hoisted_36 = { class: "borders" }
const _hoisted_37 = { class: "head" }
const _hoisted_38 = { class: "content" }
const _hoisted_39 = { class: "borders" }
const _hoisted_40 = { class: "head" }
const _hoisted_41 = { class: "content" }
const _hoisted_42 = { class: "borders" }
const _hoisted_43 = { class: "head" }
const _hoisted_44 = { class: "content" }
const _hoisted_45 = { class: "borders" }
const _hoisted_46 = { class: "head" }
const _hoisted_47 = { class: "content" }
const _hoisted_48 = {
  key: 1,
  class: "mt-6 px-2"
}
const _hoisted_49 = { class: "title" }
const _hoisted_50 = { class: "d-flex gap-4" }
const _hoisted_51 = { class: "borders" }
const _hoisted_52 = { class: "head" }
const _hoisted_53 = { class: "content" }
const _hoisted_54 = { class: "borders" }
const _hoisted_55 = { class: "head" }
const _hoisted_56 = { class: "content" }
const _hoisted_57 = { class: "borders" }
const _hoisted_58 = { class: "head" }
const _hoisted_59 = { class: "content" }
const _hoisted_60 = { class: "borders" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "MT Group", -1))
const _hoisted_62 = { class: "content" }
const _hoisted_63 = { class: "borders" }
const _hoisted_64 = { class: "head" }
const _hoisted_65 = { class: "content" }
const _hoisted_66 = { class: "borders" }
const _hoisted_67 = { class: "head" }
const _hoisted_68 = { class: "content" }
const _hoisted_69 = { class: "d-flex gap-4 mt-4" }
const _hoisted_70 = { class: "borders" }
const _hoisted_71 = { class: "head" }
const _hoisted_72 = { class: "content" }
const _hoisted_73 = { class: "borders" }
const _hoisted_74 = { class: "head" }
const _hoisted_75 = { class: "content" }
const _hoisted_76 = { class: "borders" }
const _hoisted_77 = { class: "head" }
const _hoisted_78 = { class: "content" }
const _hoisted_79 = { class: "borders" }
const _hoisted_80 = { class: "head" }
const _hoisted_81 = { class: "content" }
const _hoisted_82 = { class: "borders" }
const _hoisted_83 = { class: "head" }
const _hoisted_84 = { class: "content" }
const _hoisted_85 = { class: "borders" }
const _hoisted_86 = { class: "head" }
const _hoisted_87 = { class: "content" }
const _hoisted_88 = { class: "borders" }
const _hoisted_89 = { class: "head" }
const _hoisted_90 = { class: "content" }
const _hoisted_91 = { class: "borders" }
const _hoisted_92 = { class: "head" }
const _hoisted_93 = { class: "content" }
const _hoisted_94 = { class: "px-2" }
const _hoisted_95 = { class: "title" }
const _hoisted_96 = {
  key: 0,
  class: "d-flex gap-4"
}
const _hoisted_97 = { class: "borders" }
const _hoisted_98 = { class: "head" }
const _hoisted_99 = { class: "content" }
const _hoisted_100 = { class: "borders" }
const _hoisted_101 = { class: "head" }
const _hoisted_102 = { class: "content" }
const _hoisted_103 = { class: "borders" }
const _hoisted_104 = { class: "head" }
const _hoisted_105 = { class: "content" }
const _hoisted_106 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_107 = { class: "refer-path-border" }
const _hoisted_108 = { class: "head" }
const _hoisted_109 = { class: "content d-flex mt-1" }
const _hoisted_110 = { class: "px-2" }
const _hoisted_111 = { class: "title" }
const _hoisted_112 = { class: "row row-cols-6" }
const _hoisted_113 = { class: "d-flex flex-column" }
const _hoisted_114 = { class: "row row-cols-6 mt-4" }
const _hoisted_115 = {
  key: 4,
  class: "d-flex justify-content-center"
}
const _hoisted_116 = { class: "px-2" }
const _hoisted_117 = { class: "title" }
const _hoisted_118 = { class: "px-2" }
const _hoisted_119 = { class: "title" }

import { ref, onMounted, computed, inject, watchEffect } from "vue";
import {
  ConfigAllAccountTypeSelections,
  AccountStatusOptions,
  AccountRoleTypes,
} from "@/core/types/AccountInfos";
import { backendConfigLeverageSelections } from "@/core/types/LeverageTypes";
import { ConfigSiteTypesSelections } from "@/core/types/SiteTypes";
import { ConfigFundTypeSelections } from "@/core/types/FundTypes";
import AccountService from "../services/AccountService";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import i18n from "@/core/plugins/i18n";
import ChangePasswordForm from "./ChangePasswordForm.vue";
import ChangeCreditForm from "@/projects/tenant/modules/Payment/components/ChangeCreditForm.vue";
import ChangeAdjustForm from "@/projects/tenant/modules/Payment/components/ChangeAdjustForm.vue";
import ChangeGroupForm from "./form/ChangeGroupForm.vue";
import ChangeSalesOrAgentForm from "@/projects/tenant/modules/accounts/components/ChangeSalesOrAgentForm.vue";
import EditSalesAndAgentModal from "@/projects/tenant/modules/accounts/components/modal/EditSalesAndAgentModal.vue";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";
import AccountTags from "./form/AccountTags.vue";
import { ElNotification } from "element-plus";
import { Refresh, ArrowRight, User } from "@element-plus/icons-vue";
import EditAccountInfo from "./modal/EditAccountInfo.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import AccountPermission from "./form/AccountPermission.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountDetailInfoForm',
  emits: ["change-status"],
  setup(__props, { emit: emits }) {

const { t } = i18n.global;


const accountDetails = inject(AccountInjectionKeys.ACCOUNT_DETAILS);
const editAccountInfoRef = ref<InstanceType<typeof EditAccountInfo>>();

const changePasswordFormRef = ref<InstanceType<typeof ChangePasswordForm>>();
const changeCreditFormRef = ref<InstanceType<typeof ChangeCreditForm>>();
const changeAdjustFormRef = ref<InstanceType<typeof ChangeAdjustForm>>();
const changeSalesOrAgentFormRef =
  ref<InstanceType<typeof ChangeSalesOrAgentForm>>();
const editSalesAndAgentModalRef =
  ref<InstanceType<typeof EditSalesAndAgentModal>>();

const handleRefreshTableData = inject(
  AccountInjectionKeys.HANDLE_REFRESH_ACCOUNT_CLIENT_TABLE
);

const services = ref(Array<any>());
const serviceMap = ref({} as any);
const serverSelections = computed(() =>
  services.value
    .filter((service: any) => service.id === accountDetails.value.serviceId)
    .map((filteredItem) => filteredItem.groups)
    .reduce((acc, groups) => {
      return acc.concat(
        groups.map((group, index) => ({ label: group, value: index }))
      );
    }, [])
);

let editAccountOptions = [] as any[];
watchEffect(() => {
  // Update editAccountOptions when serverSelections changes
  editAccountOptions = [
    {
      label: t("fields.changeSiteId"),
      vModel: accountDetails.value.siteId,
      type: "siteId",
      options: ConfigSiteTypesSelections.value,
    },
    {
      label: t("fields.changeAccountType"),
      vModel: accountDetails.value.type,
      type: "accountType",
      options: ConfigAllAccountTypeSelections.value,
    },
    {
      label: t("fields.changeFundType"),
      vModel: accountDetails.value.fundType,
      type: "fundType",
      options: ConfigFundTypeSelections.value,
    },
    {
      label: t("title.changeStatus"),
      vModel: accountDetails.value.status,
      type: "status",
      options: AccountStatusOptions,
    },
    {
      label: t("action.changeLeverage"),
      vModel: accountDetails.value.tradeAccount?.tradeAccountStatus?.leverage,
      type: "leverage",
      options: backendConfigLeverageSelections,
    },
  ];
});

const openEditAccountInfoPanel = (type: number) => {
  editAccountInfoRef.value?.show(
    accountDetails.value,
    editAccountOptions[type]
  );
};
const openUserDetailSider = inject<(partyId: number) => any>(
  InjectKeys.OPEN_USER_DETAILS,
  () => null
);

const onUserClicked = () => {
  if (accountDetails.value.partyId) {
    openUserDetailSider?.(accountDetails.value.partyId);
  }
};

const editGroupFormRef = ref<InstanceType<typeof ChangeGroupForm>>();

const editGroup = () => {
  editGroupFormRef.value?.show(
    accountDetails.value.agentAccountId,
    accountDetails.value.group
  );
};

const onReAssignFinished = () => {
  handleRefreshTableData?.();
};

const successNotification = (message: string) => {
  ElNotification({
    message: message,
    type: "success",
  });
};
const refreshData = async (notification?: boolean) => {
  accountDetails.value = await AccountService.refreshMTDataById(
    accountDetails.value.id
  ).then((res) => {
    if (notification) {
      successNotification("Refresh Success");
    }
    return res;
  });
};

const tradeAccount = computed(() => accountDetails.value.tradeAccount);
const levelRule = ref(accountDetails.value.hasLevelRule.toString());
const referPath = ref([]);

const referPathConstruct = () => {
  referPath.value = accountDetails.value.referPath.split(".");
};

const HasLevelRule = async () => {
  accountDetails.value.hasLevelRule =
    accountDetails.value.hasLevelRule == 1 ? 0 : 1;
  try {
    await AccountService.updateAccountLevelRule(
      accountDetails.value.id,
      accountDetails.value.hasLevelRule
    ).then((res) => {
      successNotification("Level Rule Update Success");
      levelRule.value = accountDetails.value.hasLevelRule.toString();
    });
  } catch (error) {
    MsgPrompt.error(error);
  }
};

const openPasswordChangePanel = () =>
  changePasswordFormRef.value?.show(tradeAccount.value);

const openChangeCreditPanel = () => {
  changeCreditFormRef.value?.show(accountDetails.value.accountNumber);
};
const openChangeAdjustPanel = () => {
  changeAdjustFormRef.value?.show(accountDetails.value.accountNumber);
};

const openChangeSalesOrAgentForm = () =>
  editSalesAndAgentModalRef.value?.show(accountDetails.value);

onMounted(async () => {
  services.value = await AccountService.getServices();
  serviceMap.value = services.value.reduce((acc: any, service: any) => {
    acc[service.id] = {
      serverName: service.name,
      platform: service.platform,
      platformName: t(`type.platform.${service.platform}`),
    };
    return acc;
  }, {});
  referPathConstruct();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("fields.info")), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            icon: _unref(User),
            onClick: onUserClicked
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("title.userDetails")), 1)
            ]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(_component_el_button, {
            type: "success",
            plain: "",
            icon: _unref(Refresh),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (refreshData(true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.refresh")), 1)
            ]),
            _: 1
          }, 8, ["icon"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("fields.userName")), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(accountDetails)?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(accountDetails)?.partyId), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(accountDetails)?.uid), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(accountDetails)?.id), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
            _createElementVNode("div", _hoisted_21, [
              (_unref(accountDetails)?.accountNumber == 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t("fields.noTradeAccount")), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(accountDetails)?.accountNumber), 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("fields.accountStatus")), 1),
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t(`type.accountStatus.${_unref(accountDetails)?.status}`)), 1)
          ])
        ]),
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t("fields.basicInfo")), 1),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("fields.fundType")), 1),
              _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t(`type.fundType.${_unref(accountDetails)?.fundType}`)), 1)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t("fields.accountRole")), 1),
              _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t(`type.accountRole.${_unref(accountDetails)?.role}`)), 1)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("fields.site")), 1),
              _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t(`type.siteType.${_unref(accountDetails)?.siteId}`)), 1)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("fields.accountType")), 1),
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t(`type.account.${_unref(accountDetails)?.type}`)), 1)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("fields.group")), 1),
              _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(accountDetails)?.group), 1)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_TimeShow, {
                  "date-iso-string": _unref(accountDetails)?.createdOn,
                  format: "YYYY-MM-DD"
                }, null, 8, ["date-iso-string"])
              ])
            ])
          ])
        ]),
        (_unref(accountDetails).hasTradeAccount == true)
          ? (_openBlock(), _createBlock(_component_el_divider, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(accountDetails).hasTradeAccount == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t("fields.tradingAccountInfo")), 1),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
                  _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(accountDetails)?.accountNumber), 1)
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t("fields.currency")), 1),
                  _createElementVNode("div", _hoisted_56, _toDisplayString(_unref(t)(`type.currency.${_unref(accountDetails).tradeAccount?.currencyId}`)), 1)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t("fields.platform")), 1),
                  _createElementVNode("div", _hoisted_59, _toDisplayString(serviceMap.value[_unref(accountDetails).tradeAccount?.serviceId]?.serverName), 1)
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _hoisted_61,
                  _createElementVNode("div", _hoisted_62, _toDisplayString(_unref(accountDetails).tradeAccount.tradeAccountStatus?.group), 1)
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t("fields.lastLogin")), 1),
                  _createElementVNode("div", _hoisted_65, [
                    (
                    _unref(accountDetails).tradeAccount.tradeAccountStatus?.lastLoginOn
                  )
                      ? (_openBlock(), _createBlock(_component_TimeShow, {
                          key: 0,
                          "date-iso-string": 
                    _unref(accountDetails).tradeAccount.tradeAccountStatus?.lastLoginOn
                  ,
                          format: "YYYY-MM-DD"
                        }, null, 8, ["date-iso-string"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_component_TimeShow, {
                      "date-iso-string": _unref(accountDetails).tradeAccount?.createdOn,
                      format: "YYYY-MM-DD"
                    }, null, 8, ["date-iso-string"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.$t("fields.leverage")), 1),
                  _createElementVNode("div", _hoisted_72, _toDisplayString(_unref(accountDetails).tradeAccount.tradeAccountStatus?.leverage), 1)
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.$t("fields.balance")), 1),
                  _createElementVNode("div", _hoisted_75, _toDisplayString(_unref(accountDetails).tradeAccount.tradeAccountStatus?.balance), 1)
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.$t("fields.equity")), 1),
                  _createElementVNode("div", _hoisted_78, _toDisplayString(_unref(accountDetails).tradeAccount.tradeAccountStatus?.equity), 1)
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.$t("fields.margin")), 1),
                  _createElementVNode("div", _hoisted_81, _toDisplayString(_unref(accountDetails).tradeAccount.tradeAccountStatus?.margin), 1)
                ]),
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.$t("fields.marginLevel")), 1),
                  _createElementVNode("div", _hoisted_84, _toDisplayString(_unref(accountDetails).tradeAccount.tradeAccountStatus?.marginLevel), 1)
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.$t("fields.marginFree")), 1),
                  _createElementVNode("div", _hoisted_87, _toDisplayString(_unref(accountDetails).tradeAccount.tradeAccountStatus?.marginFree), 1)
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.$t("fields.credit")), 1),
                  _createElementVNode("div", _hoisted_90, _toDisplayString(_unref(accountDetails).tradeAccount.tradeAccountStatus?.credit), 1)
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.$t("fields.interestRate")), 1),
                  _createElementVNode("div", _hoisted_93, _toDisplayString(_unref(accountDetails).tradeAccount.tradeAccountStatus?.interestRate), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("p", _hoisted_95, _toDisplayString(_ctx.$t("fields.relationship")), 1),
          _createElementVNode("div", null, [
            (_unref(accountDetails).role != 100)
              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                  _createElementVNode("div", _hoisted_97, [
                    _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.$t("fields.referCode")), 1),
                    _createElementVNode("div", _hoisted_99, _toDisplayString(_unref(accountDetails)?.referCode), 1)
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.$t("fields.directIbId")), 1),
                    _createElementVNode("div", _hoisted_102, _toDisplayString(_unref(accountDetails)?.agentAccountId), 1)
                  ]),
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.$t("fields.directSalesId")), 1),
                    _createElementVNode("div", _hoisted_105, _toDisplayString(_unref(accountDetails)?.salesAccountId), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(accountDetails)?.referPathUids)
              ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("div", _hoisted_108, _toDisplayString(_ctx.$t("fields.referralPath")), 1),
                    _createElementVNode("div", _hoisted_109, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accountDetails)?.referPathUids, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "d-flex align-items-center gap-1 flex-wrap"
                        }, [
                          _createVNode(_component_el_tag, {
                            type: "info",
                            size: "small",
                            effect: "plain"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (index != _unref(accountDetails).referPathUids.length - 1)
                            ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ArrowRight))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_110, [
          _createElementVNode("p", _hoisted_111, _toDisplayString(_ctx.$t("action.action")), 1),
          _createElementVNode("div", _hoisted_112, [
            _createVNode(_component_el_button, {
              class: "col",
              onClick: _withModifiers(openPasswordChangePanel, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.changePassword")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              class: "col",
              onClick: _withModifiers(openChangeSalesOrAgentForm, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("action.changeSalesOrIb")), 1)
                ])
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              class: "col",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (openEditAccountInfoPanel(3)), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.changeStatus")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (openEditAccountInfoPanel(0)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.changeSiteId")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (openEditAccountInfoPanel(1)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.changeAccountType")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_114, [
            (_unref(accountDetails).role == _unref(AccountRoleTypes).IB)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  class: "col",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (editGroup()), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("fields.changeGroup")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (
                _unref(accountDetails).role == _unref(AccountRoleTypes).Client &&
                _unref(accountDetails).hasTradeAccount == true
              )
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  class: "col",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (openEditAccountInfoPanel(4)), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.changeLeverage")), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(accountDetails).role == _unref(AccountRoleTypes).Client)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  class: "col",
                  onClick: _withModifiers(openChangeAdjustPanel, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.changeAdjust")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_unref(accountDetails).role == _unref(AccountRoleTypes).Client)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 3,
                  class: "col",
                  onClick: _withModifiers(openChangeCreditPanel, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.changeCredit")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (openEditAccountInfoPanel(2)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("fields.changeFundType")), 1)
              ]),
              _: 1
            }),
            (_unref(accountDetails).role != _unref(AccountRoleTypes).Client)
              ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                  _createVNode(_component_el_switch, {
                    modelValue: levelRule.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((levelRule).value = $event)),
                    "inline-prompt": "",
                    size: "large",
                    style: {"--el-switch-on-color":"#137640","--el-switch-off-color":"#c03636"},
                    "active-text": " Level Rule On ",
                    "inactive-text": " Level Rule Off ",
                    "inactive-value": "0",
                    "active-value": "1",
                    onClick: _withModifiers(HasLevelRule, ["prevent"])
                  }, null, 8, ["modelValue", "onClick"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_116, [
          _createElementVNode("p", _hoisted_117, _toDisplayString(_ctx.$t("fields.permission")), 1),
          _createVNode(AccountPermission)
        ]),
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_118, [
          _createElementVNode("p", _hoisted_119, _toDisplayString(_ctx.$t("title.options")), 1),
          _createVNode(AccountTags, { accountDetails: _unref(accountDetails) }, null, 8, ["accountDetails"])
        ])
      ])
    ]),
    _createVNode(ChangePasswordForm, {
      ref_key: "changePasswordFormRef",
      ref: changePasswordFormRef
    }, null, 512),
    _createVNode(ChangeCreditForm, {
      ref_key: "changeCreditFormRef",
      ref: changeCreditFormRef
    }, null, 512),
    _createVNode(ChangeAdjustForm, {
      ref_key: "changeAdjustFormRef",
      ref: changeAdjustFormRef
    }, null, 512),
    _createVNode(ChangeGroupForm, {
      ref_key: "editGroupFormRef",
      ref: editGroupFormRef
    }, null, 512),
    _createVNode(ChangeSalesOrAgentForm, {
      ref_key: "changeSalesOrAgentFormRef",
      ref: changeSalesOrAgentFormRef,
      onReAssignFinished: onReAssignFinished
    }, null, 512),
    _createVNode(EditAccountInfo, {
      ref_key: "editAccountInfoRef",
      ref: editAccountInfoRef,
      onRefresh: refreshData
    }, null, 512),
    _createVNode(EditSalesAndAgentModal, {
      ref_key: "editSalesAndAgentModalRef",
      ref: editSalesAndAgentModalRef,
      onUpdate: refreshData
    }, null, 512)
  ]))
}
}

})